export default __webpack_public_path__ + "static/media/icon-refrigerator.8349ef6d.svg";